// Razorpay Configuration
// This file contains only the public key - secret keys are never exposed in frontend

const RAZORPAY_CONFIG = {
  // Public key - safe to expose in frontend
  keyId: process.env.REACT_APP_RAZORPAY_KEY_ID,
  
  // API base URL for backend calls
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || '',
  
  // Currency
  currency: 'INR',
  
  // Company details for payment UI
  companyName: 'Business Copilot',
  companyDescription: 'AI-Powered Content Creation Platform'
};

export default RAZORPAY_CONFIG;
